export default "__VITE_ASSET__CjxSfXJn__"